<template>
    <div id="preloader" :style="`width:${size}px; height:${size}px`">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 520 520" style="enable-background:new 0 0 520 520;" xml:space="preserve">
        <path class="lettera-o" d="M419.5,347.3c0,88.1-64,165.9-159.7,165.9c-96.4,0-160.4-77.8-160.4-165.9s64-165.9,160.4-165.9
            C355.5,181.4,419.5,259.2,419.5,347.3 M356.2,347.3c0-66.8-14.5-163.1-96.4-163.1s-97,96.4-97,163.1c0,66.8,15.1,162.4,97,162.4
            C341.8,509.8,356.2,414.1,356.2,347.3"/>
        <path class="accento" d="M294.9,119.5l-2.7,2.1c0,0-61.3-57.8-77.1-73c-13.8-14.5-18.6-27.5-6.2-37.2c11.7-9.6,24.1-1.4,33.7,15.8
            C254.3,45.8,294.9,119.5,294.9,119.5"/>
        </svg>
        <div class="text">Loading</div>
    </div>
</template>
<script>
export default {
    props: {
        size: {
        type: String,
        default: '80'
      }
    }
}
</script>

<style scoped lang="scss">
#preloader {
    display: block;
    margin: 40px auto;
    svg {
        animation: total 0.55s ease-in-out infinite;
        width: 100%;
        .lettera-o {

        }

        .accento {
            transform: translate(0, 20px);
            animation: accento 0.75s ease-in-out infinite;
            animation-delay: 1s;
        }

    }

    .text {
        font-size: 0.9rem;
        text-align: center;
    }
}

@keyframes total {
    0% {
        transform: translate(0, 0);
    }

    60% {
        transform: translate(0, -40px);     
    }

    100% {
        transform: translate(0, 0);
    }
}


@keyframes accento {
    0% {
        transform: translate(0, 20px);
    }

    60% {
        transform: translate(0, 0px);     
    }

    100% {
        transform: translate(0, 20px);
    }
}
</style>